export class RandomWildEvents {
    public static readonly RANDOM_WILD_FEATURE_FINISHED: symbol = Symbol('RANDOM_WILD_FEATURE_FINISHED');
    public static readonly WILD_LANDED: symbol = Symbol('WILD_LANDED');
    public static readonly SHOULD_START_DARKENING: symbol = Symbol('SHOULD_START_DARKENING');
    public static readonly ACTIVATOR_WIN_STARTED: symbol = Symbol('ACTIVATOR_WIN_STARTED');
    public static readonly ACTIVATOR_WIN_FINISHED: symbol = Symbol('ACTIVATOR_WIN_FINISHED');
}
